"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCompleteUploadDto = instanceOfCompleteUploadDto;
exports.CompleteUploadDtoFromJSON = CompleteUploadDtoFromJSON;
exports.CompleteUploadDtoFromJSONTyped = CompleteUploadDtoFromJSONTyped;
exports.CompleteUploadDtoToJSON = CompleteUploadDtoToJSON;
exports.CompleteUploadDtoToJSONTyped = CompleteUploadDtoToJSONTyped;
/**
 * Check if a given object implements the CompleteUploadDto interface.
 */
function instanceOfCompleteUploadDto(value) {
    return true;
}
function CompleteUploadDtoFromJSON(json) {
    return CompleteUploadDtoFromJSONTyped(json, false);
}
function CompleteUploadDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'etag': json['etag'] == null ? undefined : json['etag'],
    };
}
function CompleteUploadDtoToJSON(json) {
    return CompleteUploadDtoToJSONTyped(json, false);
}
function CompleteUploadDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'etag': value['etag'],
    };
}
